export default "__VITE_ASSET__BR9n7XWx__"